import React, { useContext } from "react";

import "./MainLayout.scss";
import { Divider, Layout, Menu, Popover, Modal, Tooltip } from "antd";
import Icon from "../Icons/Icons";
import { Route, useLocation, useNavigate } from "react-router-dom";
import Typography from "../Typography/Typography";
import Card from "../Card/Card";
import InvertedPrimaryButton from "../InvertedPrimaryButton/InvertedPrimaryButton";
import { Box, Tabs, Tab, Link, Li } from "@mui/material";

// import { userProfileContext } from "../../context/states/index";
import useProfile from "../../hooks/useSetUserProfile";
import Icons from "../Icons/Icons";

import { contactSalesApi, loginApi } from "../../api/index";
import UserContext from "../../storage/context/userProfileContext";
import { WarehouseContext } from "../../storage/context";
import { docs_home } from "../../constants/urls";
import { useState } from "react";
import { useEffect } from "react";
import Sidebar from "./Sidebar";
import { API_DOCS_CLICK, DISCORD_CLICK, LOGOUT_CLICK, SIDEBAR_GO_LIVE_CLICK, SCHEDULE_A_CALL_CLICK, trackEvent } from "../../analytics";
import {
  creatorModuleProductID,
  creatorModuleSpecificTenantID,
  Creators,
  Developers,
  MEETING_SCHEDULE_LINK,
  Production,
  Sandbox,
  Staging,
} from "../../constants/constants";
import { isCreatorModuleSpecificTenant } from "../../utils/util";
import { ADD_ENVIRONMENT, UPDATE_ENVIRONMENT_BASE_URL } from "../../storage/reducers/types";
// import WebhookPage from "../WebhookPage/WebhookPage";
// import HelpPage from "../HelpPage/HelpPage";

const { Header, Content, Sider } = Layout;

const ContactSalesModalConfig = {
  title: (
    <Typography h3 style={{ fontWeight: "600" }}>
      Thank you for applying for production access to Phyllo APIs! Our team will be in touch with you shortly. Thank you for applying for production
      access to Phyllo APIs! Our team will be in touch with you shortly.
    </Typography>
  ),
  content: (
    <div>
      <p className="contact-sales-card-description">
        In the meanwhile, if you have any questions feel free to drop a line to{" "}
        <a href="mailto:support@getphyllo.com">
          <u>support@getphyllo.com</u>
        </a>{" "}
        or
        <a href={MEETING_SCHEDULE_LINK} target="_blank" rel="noreferrer">
          {" "}
          <u>book a meeting</u>
        </a>{" "}
        with our product experts.{" "}
      </p>
      <p className="contact-sales-card-description">Happy building!</p>
    </div>
  ),
  closeIcon: <Icons.close_circle_fill />,
  closable: true,
  icon: false,
  cancelText: null,
  okType: "text",
  okButtonProps: { style: { backgroundColor: "transparent", height: "65px" } },
  okText: <InvertedPrimaryButton label="Got it!" />,
};

const TabValues = ["Creators", "Developers"];
const indexToTabName = {
  creators: 0,
  developers: 1,
};
const tabNameToIndex = {
  0: "creators",
  1: "developers",
};

const getPathName = (string) => {
  return string.charAt(0).toLowerCase() + string.slice(1);
};

const MainLayout = ({ children, className = "" }) => {
  const navigate = useNavigate();
  const { logoutUserProfile } = useProfile();
  const location = useLocation();
  // const [loading, setIsLoading] = useState(false);
  const {
    warehouse: { tenantInfo, showCreatorLinkageModule, productionKeys },
    warehouse,
    dispatchWarehouse,
  } = useContext(WarehouseContext);

  const { userProfile, dispatchUserProfile } = useContext(UserContext);
  let isProductionAvailableForCreatorModule =
    productionKeys.productionEnabledTenantProducts.filter((product) => product.product_id === creatorModuleProductID).length > 0;

  //setting the default tab value based on the route value
  const [value, setValue] = useState(
    location.pathname.includes(`/${getPathName(Developers)}`) ? indexToTabName["developers"] : indexToTabName["creators"]
  );

  const handleChange = (event, newValue) => {
    setValue(() => {
      return newValue;
    });
    navigate(`/${tabNameToIndex[newValue]}`);
  };

  const onContactSalesClick = async () => {
    try {
      trackEvent(SIDEBAR_GO_LIVE_CLICK, { email: userProfile.user.email });
      Modal.info(ContactSalesModalConfig);
      await contactSalesApi.contactSales();
    } catch (e) {
      console.log(e);
      // do nothing for now
    }
  };

  const handleLogout = async () => {
    // setIsLoading(true);
    trackEvent(LOGOUT_CLICK);
    try {
      await loginApi.signOutUser();
      logoutUserProfile();
    } catch (e) {
      // do nothing
      // setIsLoading(true);

      console.log(e, "logout error");
    }
  };

  useEffect(() => {
    if (!userProfile.user.token) {
      // TODO: Static code for LinkInfra
      if (location.pathname === "/link-demo") {
        navigate("/link-demo");
        return;
      }

      navigate("/sign-in");

      // For updating the analytics in localStorage
      navigate(0);
    }
  }, [userProfile]);

  useEffect(() => {
    // if (tabNameToIndex[value] === "creators") {
    //   if (
    //     localStorage.getItem("currentEnv") === null ||
    //     localStorage.getItem("currentEnv") === Sandbox ||
    //     localStorage.getItem("currentEnv") === Production
    //   ) {
    //     localStorage.setItem("currentEnv", Staging);
    //     dispatchWarehouse({ type: ADD_ENVIRONMENT, payload: Staging });
    //   }
    // } else {
    //   if (localStorage.getItem("currentEnv") === null) {
    //     localStorage.setItem("currentEnv", Sandbox);
    //     dispatchWarehouse({ type: ADD_ENVIRONMENT, payload: Sandbox });
    //   }
    // }
    // if (tabNameToIndex[value] === "developers") {
    if (warehouse.environment.current === Sandbox || (warehouse.environment.current === Production && !isProductionAvailableForCreatorModule)) {
      localStorage.setItem("currentEnv", Staging);
      dispatchWarehouse({ type: ADD_ENVIRONMENT, payload: Staging });
      dispatchWarehouse({
        type: UPDATE_ENVIRONMENT_BASE_URL,
        payload: warehouse.environment.environmentURLMapping[Staging],
      });
      dispatchUserProfile({ type: ADD_ENVIRONMENT, payload: Staging });
    }
    // }
  }, [value]);

  return (
    <Layout style={{ height: "100vh" }}>
      <Header className="main-header">
        {/* <Modal okButtonProps=/> */}
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <Icon.phyllo_icon_with_name className="main-logo" />
          </div>
          <div>
            {/* {showCreatorLinkageModule && ( */}
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" className="tabs">
              <Tab className="tab" label="Creators" value={0} />
              <Tab className="tab" label="For developers" value={1} />
            </Tabs>
            {/* )} */}
          </div>
        </div>
        {/* <Box sx={{ borderBottom: 1, borderColor: "divider" }}> */}
        {/* </Box> */}
        {/* <TabPanel value={value} index={0}>
          Creators
        </TabPanel>
        <TabPanel value={value} index={1}>
          For developers
        </TabPanel> */}
        <div className="header-right-title-section">
          <LinkText title="Schedule a call" event={SCHEDULE_A_CALL_CLICK} to={MEETING_SCHEDULE_LINK} />
          <LinkText title="Discord Community" event={DISCORD_CLICK} to="https://discord.gg/FqPgyeWu37" />
          <LinkText title="Docs" event={API_DOCS_CLICK} to={docs_home} />
          <Popover
            arrowPointAtCenter={false}
            placement="bottomRight"
            overlayInnerStyle={{
              backgroundColor: "#222838",
              borderRadius: "4px",
              padding: "8px",
              textOverflow: "ellipsis",
            }}
            content={
              <LogoutPopoverContent
                email={userProfile.user.email}
                name={userProfile.user.firstName + " " + (userProfile.user.lastName ? userProfile.user.lastName : "")}
                onPressLogout={handleLogout}
              />
            }
          >
            <Icon.profile className="profile-icon" />
          </Popover>
        </div>
      </Header>

      <Layout style={{ height: "100%" }}>
        <Sidebar onContactSalesClick={onContactSalesClick} currentTab={TabValues[value]} />

        <Content className={`site-layout-background ${className} content-section`}>
          {/* {TabValues[value] === Developers && ( */}
          <div
            className="site-layout-environment-specifier"
            style={
              warehouse.environment.current === Staging
                ? {
                    backgroundColor: "#BEE4FF",
                  }
                : warehouse.environment.current === Production
                ? {
                    backgroundColor: "#96EAC6",
                    height: "2px",
                  }
                : { backgroundColor: "#FDEDBE" }
            }
          >
            {warehouse.environment.current !== Production && <span>You are in {warehouse.environment.current.toLowerCase()} mode.</span>}
          </div>
          {/* )} */}
          <div className="scrolling-page-content">
            <div className="page-content">{children}</div>
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

const LinkText = ({ title, event, to }) => {
  return (
    <div
      className="link-header"
      onClick={() => {
        trackEvent(event, { url: to, page_name: window.location.pathname.substring(1).toUpperCase(), source: "TOP_NAV" });
        window.open(to, "_blank");
      }}
    >
      <Typography h4>{title}</Typography>
      <Icon.link_to_icon />
    </div>
  );
};

const LogoutPopoverContent = ({ name = "", email = "", onPressLogout }) => {
  return (
    <Card className="logout-popover">
      <Typography h1 className="profile-popup-user-name">
        {name}
      </Typography>
      <p className="profile-email">{email}</p>
      <Divider
        style={{
          background: "#414251",
          marginTop: "10px",
          marginBottom: "16px",
        }}
      />
      <button onClick={onPressLogout} className="logout-button-container">
        <Icon.exit_logout />
        Logout
      </button>
    </Card>
  );
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && (
        <Box sx={{ padding: "0px" }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

function LinkTab(props) {
  return (
    <Tab
      component="a"
      onClick={(event) => {
        event.preventDefault();
      }}
      {...props}
    />
  );
}

export default MainLayout;
